import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "@common/Modal/Modal";
import { TITLE_INHERIT_STYLE } from "@constants";
import { ReplacementSimForm } from "./ReplacementSimForm";
import { useGetSubscription } from "@common/SelectYourNumber/hook/useGetSubscription";
import { HandleErrorAndLoading } from "@common/handleErrorAndLoading/HandleErrorAndLoading";
import { ICustomService } from "@common/SelectYourNumber/interface/ISubscription";

interface IParams {
    selectedService: ICustomService;
}

export const ReplacementSim = (props: IParams) => {
    const { selectedService } = props;
    const { simReplacePending, getReplacePendingState, getSimReplacePending } = useGetSubscription(true);
    const [isFormDisplayed, setIsFormDisplayed] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { t } = useTranslation(["sim", "glossary"]);

    const closeModal = () => setIsModalOpen(false);
    const displayModal = () => setIsModalOpen(true);
    const closeForm = () => setIsFormDisplayed(false);

    useEffect(() => {
        getSimReplacePending();
    }, [selectedService]);

    return (
        <Fragment>
            <Card className="replacementSim" elevation={2}>
                <CardHeader
                    className="card-header card-header__right"
                    title={t("sim:replaceSim")}
                    titleTypographyProps={TITLE_INHERIT_STYLE}
                />
                <CardContent className="replacementSim-content">
                    <div className="card-header__circle" />
                    <HandleErrorAndLoading
                        error={getReplacePendingState.error}
                        isLoading={getReplacePendingState.isLoading}
                        retryFetch={getSimReplacePending}
                    >
                        {simReplacePending ? (
                            <>
                                <div className="replacementSim__text">
                                    <Typography align="center" variant="body1">
                                        {t("sim:simReplacementRequestPending")}
                                    </Typography>
                                </div>
                            </>
                        ) : (
                            <>
                                {isFormDisplayed && (
                                    <ReplacementSimForm
                                        closeForm={closeForm}
                                        displayModal={displayModal}
                                        getSimReplacePending={getSimReplacePending}
                                    />
                                )}
                                {!isFormDisplayed && (
                                    <Fragment>
                                        <div className="replacementSim__text">
                                            <Typography align="center" variant="body1">
                                                {t("sim:replaceYourSimHelperText")}
                                            </Typography>
                                        </div>
                                        <Grid container item justify="center">
                                            <Button
                                                color="secondary"
                                                size="large"
                                                variant="outlined"
                                                onClick={() => setIsFormDisplayed(true)}
                                            >
                                                {t("sim:replaceSim")}
                                            </Button>
                                        </Grid>
                                    </Fragment>
                                )}
                            </>
                        )}
                    </HandleErrorAndLoading>
                </CardContent>
            </Card>
            <Modal
                close={closeModal}
                confirm={closeModal}
                confirmLabel={t("glossary:close")}
                content={t("sim:replacementSimSuccess")}
                isModalOpen={isModalOpen}
                title=""
            />
        </Fragment>
    );
};
